/**
 * 签约相关API接口
 */
import request from '@/utils/request'
import type { ApiResponse } from '@/types/models'

// 页面状态类型
export type PageStatus = 
  | 'no_application'  // 未提交申请
  | 'reviewing'       // 审核中
  | 'in_progress'     // 流程进行中
  | 'rejected'        // 审核未通过
  | 'cancelled'       // 已取消
  | 'pending_sign'    // 待签约
  | 'signed'          // 已签约
  | 'other'           // 其他状态

// 申请信息
export interface ApplicationInfo {
  id: number
  application_no: string
  current_step: number
  status: string
  submit_time: string
  review_notes?: string
}

// 签约邀请响应（包含页面状态）
export interface ContractInvitationResponse {
  page_status: PageStatus
  page_message: string
  page_description?: string
  // 签约信息（仅在 pending_sign 或 signed 状态时存在）
  id?: string
  contract_number?: string
  community_name?: string
  cooperation_period?: string
  agreement_content?: string
  status?: string
  signed_at?: string
  created_at?: string
  // 申请信息（仅在非签约状态时存在）
  application?: ApplicationInfo | null
}

export interface ContractInvitation {
  id: string
  contract_number: string
  community_name: string
  cooperation_period: string
  agreement_content: string
  status: string
  created_at: string
}

export interface SignResult {
  contract_id: string
  contract_number: string
  signed_at: string
  message: string
}

export const contractApi = {
  /**
   * 获取签约邀请信息（包含页面状态）
   */
  getInvitation() {
    return request<ApiResponse<ContractInvitationResponse>>({
      url: '/api2/contracts/invitation',
      method: 'get'
    })
  },

  /**
   * 发送签约验证码
   */
  sendVerificationCode() {
    return request<ApiResponse<{
      message: string
      expire_seconds: number
      dev_code?: string
    }>>({
      url: '/api2/contracts/send-code',
      method: 'post'
    })
  },

  /**
   * 确认签约
   */
  confirmSign(data: {
    contract_id: string | number
    verification_code: string
    signature_data: string
  }) {
    return request<ApiResponse<SignResult>>({
      url: '/api2/contracts/sign',
      method: 'post',
      data
    })
  },

  /**
   * 获取签约详情
   */
  getContractDetail(id: string | number) {
    return request<ApiResponse<ContractInvitation>>({
      url: `/api2/contracts/${id}`,
      method: 'get'
    })
  }
}

export default contractApi
